export function getValueConsent(value) {
  return (
    value ||
    `I agree to be contacted by the practice for the purposes of scheduling or important communications related to my treatment. This consent is required to proceed. For SMS, message and data rates may apply. Message frequency varies. Reply STOP to opt-out.`
  )
}

export function getValueMarketing(value) {
  return (
    value ||
    `I agree that the practice may share my contact information with trusted partners so they can send me relevant offers and promotions. Reply STOP to opt-out.`
  )
}
